import { MasterImport } from './Imports'
const { RoutesMap, CountryList, StateList, DistrictList, TehsilList, NatureList, StructureList, CropList, BioMasterList, DiseaseMasterList, StageList, RequestTypeList } = MasterImport

const MasterRoute = () => {
    return [
        {
            path: RoutesMap.COUNTRY_LIST.path,
            element: <CountryList />
        },


        {
            path: RoutesMap.STATE_LIST.path,
            element: <StateList />
        },


        {
            path: RoutesMap.DISTRICT_LIST.path,
            element: <DistrictList />
        },


        {
            path: RoutesMap.TEHSIL_LIST.path,
            element: <TehsilList />
        },


        {
            path: RoutesMap.NATURE_LIST.path,
            element: <NatureList />
        },


        {
            path: RoutesMap.STRUCTURE_LIST.path,
            element: <StructureList />
        },


        {
            path: RoutesMap.CROP_LIST.path,
            element: <CropList />
        },


        {
            path: RoutesMap.BIO_MASTER_LIST.path,
            element: <BioMasterList />
        },


        {
            path: RoutesMap.DISEASE_MASTER_LIST.path,
            element: <DiseaseMasterList />
        },


        {
            path: RoutesMap.STAGE_LIST.path,
            element: <StageList />
        },

        {
            path: RoutesMap.REQUEST_TYPE_LIST.path,
            element: <RequestTypeList />
        },
    ]
}

export default MasterRoute;